import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import { formatPrice } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FacadeOptions',
  props: {
    facades: {
      type: Array,
      default: () => [],
    },
    initialSelectedFacade: {
      type: String,
      default: null,
    },
  },
  emits: ["selectFacade"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const selectedFacadeId = ref<string | null>(props.initialSelectedFacade);

  const onSelectFacade = (
    id: string,
    url: string,
    facadeName: string,
    facadePrice: string | number
  ) => {
    selectedFacadeId.value = id;
    emit("selectFacade", selectedFacadeId.value, url, facadeName, facadePrice);
  };

  const getButtonLabel = (id: string) => {
    return selectedFacadeId.value !== null && id !== selectedFacadeId.value
      ? "Change"
      : "Select";
  };

  onMounted(() => {
    if (props.initialSelectedFacade) {
      const facade = props.facades.find(
        (facade) => facade._id === props.initialSelectedFacade
      );

      if (facade) {
        onSelectFacade(facade._id, facade.url, facade.name, facade.price);
      }
    }
  });

const __returned__ = { props, emit, selectedFacadeId, onSelectFacade, getButtonLabel, onMounted, ref, get formatPrice() { return formatPrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})